import { AppStore } from '@aeins/core';
import { inject, Injectable } from '@angular/core';
import { widgetsMap } from 'app/widgets/widgets-map';
import { merge } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    private readonly _appStore = inject(AppStore);

    async init(): Promise<any> {
        const { pages, areas, translations, settings, themes } = await this._getSetupData();
        await this._appStore.init(pages, areas, translations, settings, themes, widgetsMap);
    }

    private async _getSetupData() {
        const pages = await this._getJson('./assets/config/pages.json');
        const areas = await this._getJson('./assets/config/areas.json');
        const translations = await this._getTranslations();
        const settings = await this._getJson('./assets/config/settings.json');
        const themes = await this._getJson('./assets/config/themes.json');
        return { pages, areas, translations, settings, themes };
    }

    private async _getJson(path: string): Promise<any> {
        return await (await fetch(path)).json();
    }

    private async _getTranslations(): Promise<any> {
        return await ['de', 'en'].reduce(
            async (accPromise, lang) => {
                const acc = await accPromise;
                const coreTranslations = await this._getJson(`./assets/@aeins/core/i18n/${lang}.json`);
                const componentsTranslations = await this._getJson(`./assets/@aeins/components/i18n/${lang}.json`);
                const appTranslations = await this._getJson(`./assets/config/i18n/${lang}.json`);
                acc[lang] = merge(coreTranslations, componentsTranslations, appTranslations);
                return acc;
            },
            Promise.resolve({} as Record<string, any>),
        );
    }
}
